import { businessKey } from 'queryKeys';

export const MAIN_BUDGET_PLANNING = 'mainBudgetPlanning';
const mainBudgetPlanningQuery = businessKey.query(MAIN_BUDGET_PLANNING);

const EXPORT = 'exportMainBudgetPlanning';
const IMPORT = 'importMainBudgetPlanning';

export const grid = mainBudgetPlanningQuery.grid();

export const model = mainBudgetPlanningQuery.exact();

export const mutations = mainBudgetPlanningQuery.mutations();

export const create = mutations.create();
export const update = mutations.update();
export const remove = mutations.delete();

export const exportMainBudgetPlanning = mutations.mutate(EXPORT);
export const importMainBudgetPlanning = mutations.mutate(IMPORT);
